module.exports = __webpack_public_path__ + "img/IMG_8971.4c7cdcc1.jpg";